// extracted by mini-css-extract-plugin
module.exports = {"MiniModal":"info-card_MiniModal__3p5L6","Header":"info-card_Header__2_vPD","CloseButton":"info-card_CloseButton__2wohb","Content":"info-card_Content__28jO3"};